(function () {
    'use strict';

    function adminEntityConfigurationEditorController($scope, $log, adminEntityConfigurationData, configurationOptionsData,
        adminEntityConfigurationDataService, notifyService) {

        var self = this;

        this.current = adminEntityConfigurationData;
        this.current.FriendlyId = adminEntityConfigurationData.Id.split('/')[1];
        this.configurationOptions = configurationOptionsData;
        this.errors = [];

        // Remove function
        this.removeItem = function (target, index) {
            target.splice(index, 1);
        };

        // Add function
        this.addItem = function (target, property, data) {
            if (target[property] === undefined) {
                target[property] = [];
            }

            target[property].push(data || {});
        };

        this.logConfiguration = function () {
            $log.debug(self.current);
        };


        this.saveConfiguration = function () {
            if ($scope.adminEntityConfigurationForm.$valid) {
                self.errors = [];
                return adminEntityConfigurationDataService.save(self.current.FriendlyId, angular.toJson(self.current)).then(
                function (response) {
                    notifyService.notify('The configuration was saved successfully');
                },
                function (response) { self.errors = response.data; });
            } else {
                self.errors = ['Form errors'];
                return false;
            }
        };
    }

    adminEntityConfigurationEditorController.$inject = ['$scope', '$log', 'adminEntityConfigurationData', 'configurationOptionsData',
        'adminEntityConfigurationDataService', 'notifyService'];

    angular.module('ecap.siteConfiguration').controller('adminEntityConfigurationEditorController', adminEntityConfigurationEditorController);
})();
